import { createRoot } from "react-dom/client";
import ServiceRegistrationButton from "./components/ServiceRegistrationButton";
import { store } from "./app/store";
import { Provider } from 'react-redux'
import { PrimeReactProvider } from 'primereact/api';
import { ConfigContext } from './ConfigContext';
import Tailwind from 'primereact/passthrough/tailwind';
import './styles/index.css'
import { Toast } from "primereact/toast";
import { toastRef } from "./components/GlobalToastRef";
var rootelement = document.getElementById('serviceregistration-root');
if(rootelement) {        
    const root = createRoot(rootelement);
    const csrfCookieName = rootelement.getAttribute('data-csrf-cookie-name')
    const firmId = rootelement.getAttribute('data-firm')
    root.render(
        <Provider store={store}>
            <PrimeReactProvider value={{ unstyled: false, pt: Tailwind }}>
                <ConfigContext value={{csrfCookieName, firmId }}>
                    <Toast ref={toastRef}/>
                    <ServiceRegistrationButton />
                </ConfigContext>
            </PrimeReactProvider>
        </Provider>
    );
}